<template>
  <div class="type_select_action" :class="{ loading }">
    <div class="loading_spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="title">Вход под пользователем</div>
    <div>
      <div class="loginHolder select_and_action">
        <input-module
          type="select"
          v-model="user_email"
          :values="users"
          valueKey="email"
          valueName="title"
          style="
            width: 90%;
            padding: 0;
            padding-left: 5px;
            margin: 0;
            display: inline-block;
          "
        />
        <button class="login" @click="loginAs">
          <i class="fal fa-sign-in-alt"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loginHolder {
  margin-top: 20px;
  position: relative;
  button {
    background: unset;
    color: black;
    border: unset;
    position: absolute;
    top: 1px;
    right: -2px;
    font-size: 20px;
    opacity: 0.8;
    &:hover {
      opacity: 1;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .loginHolder {
    button {
      color: white;
    }
  }
}
</style>

<script>
import InputModule from "../../Components/InputModule.vue";
let apiDriver = require("../../apiDriver").default;
let moment = require("moment");

export default {
  name: "admin_loginAs",
  components: { InputModule },
  data: function () {
    return {
      loading: true,
      users: [],
      user_email: "",
    };
  },
  methods: {
    moment,
    declOfNum: function (number, titles) {
      var cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    getData: async function () {
      this.loading = true;

      let users = (await apiDriver.admin.users.list()).users;
      this.users = users.map((user) => {
        return {
          id: user.id,
          name: `${
            user.name.length > 12 ? user.name.slice(0, 12) + "..." : user.name
          }`,
          email: user.email,
          title: `${user.id}, ${user.name} (${user.email})`,
        };
      });
      this.user_email = users[0].email;

      this.loading = false;
    },
    async loginAs() {
      let token = (await apiDriver.admin.users.loginAs(this.user_email)).token;
      localStorage.returnAdminToken = localStorage.token;
      localStorage.token = token;
      document.location.href = "/";
    },
  },
  mounted: function () {
    this.getData();
  },
};
</script>